@if (!loadingInit) {
  <div class="card m-2">
    @if (regConfig5.length>0) {
      <app-dynamic-form #myform23 [options]="form2Opts" [fields]="regConfig5" (submit)="submit2($event)"
        (onSwitchChange)="switchChange($event)" (onCheckboxChange)="checkbocChange($event)">
      </app-dynamic-form>
    }
  </div>
}

@if (loadingInit) {
  <div class="rounded-2xl p-2 bg-primary-500/50 m-2">
    <h1>CHECKING IF YOU ARE AUTHORIZED 💀💀💀💀💀💀💀💀💀</h1>
  </div>
}

@if (showErr) {
  <div class="rounded-2xl p-2 bg-primary-500/50 m-2">
    <h1>YOU MOFO YOU CAN'T SEE THE PRIVATE SHIT IN HERE</h1>
    <h1>☠️☠️☠️☠️☠️☠️☠️☠️☠️🫨🫨🫨🫨😱😱😱😱😱😱😱☠️☠️☠️☠️☠️☠️☠️☠️☠️</h1>
    <h1>💀💀💀💀💀💀💀💀💀💀💀😿😿😿😿😿😿😿😿😿😿😿</h1>
  </div>
}

